import { Button, Preloader } from '@cian/components';
import * as React from 'react';
import { ILocation } from '../../../api/locations';
import { CloseBtn } from '../../../common/components/close_button';
import { Modal } from '../../../common/components/modal';
import { ModalWrapper } from '../../../common/components/modal/wrapper';
import { SearchButtonContainer } from '../search_button/container';
import { Areas } from './areas';
import { Breadcrumbs } from './breadcrumb';
import { Capitals } from './capitals/';
import { trackApplySelectedLocation } from './tracking';

const style = require('./index.css');

export interface ILocationSwitherProps {
  autocomplete: React.ReactNode;
  cities: ILocation[] | undefined;
  isDataLoading: boolean;
  regions: ILocation[];
  selectedCity: ILocation | undefined;
  selectedRegion: ILocation | 'moscow_mo' | 'spb_lo' | undefined;
  jsonQueryUrl: string | undefined;

  applySelectedLocation(): void;
  onCitySelected(city: ILocation): void;
  onClose(): void;
  onCountrySelected(): void;
  onRegionSelected(region: ILocation | 'moscow_mo' | 'spb_lo'): void;
}

export class LocationSwither extends React.Component<ILocationSwitherProps> {
  public render() {
    const { selectedRegion, selectedCity, isDataLoading } = this.props;

    return (
      <ModalWrapper onClose={this.props.onClose}>
        <Modal
          minHeigth={200}
          minWidth={1000}
          width="85%"
          header={
            <div className={style.header}>
              <div className={style.autoComplete}>
                {this.props.autocomplete}
                {this.renderBreadcrumbs()}
              </div>
            </div>
          }
          closeBtn={<CloseBtn onClick={this.props.onClose} isTransparent />}
          footer={
            <div className={style.footer}>
              {selectedCity || selectedRegion ? (
                <SearchButtonContainer onClick={this.handleClickOnSearchButton} />
              ) : (
                this.renderCancelButton()
              )}
            </div>
          }
        >
          <div className={style.locationSwitcher}>
            {isDataLoading && (
              <div className={style.preloaderWrapper}>
                <Preloader size={50} preloaderStyle={style.preloader} />
              </div>
            )}
            <Capitals
              selectedCity={selectedCity}
              selectedRegion={selectedRegion}
              regions={this.props.regions}
              onRegionSelected={this.props.onRegionSelected}
            />
            {selectedCity ? this.renderCities() : selectedRegion ? this.renderCities() : this.renderRegions()}
          </div>
        </Modal>
      </ModalWrapper>
    );
  }

  private renderBreadcrumbs() {
    const { selectedRegion, selectedCity } = this.props;

    return (
      <Breadcrumbs
        selectedCity={selectedCity}
        selectedRegion={selectedRegion}
        regions={this.props.regions}
        onCitySelected={this.props.onCitySelected}
        onCountrySelected={this.props.onCountrySelected}
        onRegionSelected={this.props.onRegionSelected}
      />
    );
  }

  private renderRegions() {
    return (
      <Areas
        areas={this.props.regions}
        onSelected={this.props.onRegionSelected}
        onRegionSelected={this.props.onRegionSelected}
      />
    );
  }

  private renderCities() {
    return (
      <Areas
        areas={this.props.cities}
        onSelected={this.props.onCitySelected}
        selectedCity={this.props.selectedCity}
        selectedRegion={this.props.selectedRegion}
        onRegionSelected={this.props.onRegionSelected}
      />
    );
  }

  private renderCancelButton() {
    return (
      <Button theme="button/solid" disabled={true} onClick={this.props.onClose}>
        Выберите регион
      </Button>
    );
  }

  private handleClickOnSearchButton = () => {
    trackApplySelectedLocation(this.props.jsonQueryUrl);
    this.props.applySelectedLocation();
  };
}
